import initSliders from "../components/initSliders.js";
import initLightbox from "../components/initLightbox.js";

document.addEventListener("DOMContentLoaded", () => {

    initLightbox();

    const {
        initPhotosSlider,
    } = initSliders();

    initPhotosSlider();
});
